import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CardInfoField from "../../../../../../ui/CardInfoField";
import ProgramImage from "../ProgramImage";
import { Typography } from "@material-ui/core";
import Button from "../../../../../../ui/Button";
import Progress from "../../../../../../ui/Progress";
import {ReactComponent as ClockIconSmall} from "../../../../../../images/state/clock_24.svg";
import { SmallStateIcon, StateTextColor } from "../../components/StateStyles";
import Grid from "@material-ui/core/Grid";
import CardPersonBlock from "../../../../../../ui/CardPersonBlock";
import { getModule } from "../../store/actions";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  hide: {
    display: "none"
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
  devider: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px dashed #CACCD1"
  },
  stateBlock: {
    marginTop: 16,
    marginBottom: 8,
    height: 20,
    display: "block",
    width: "240px",
    boxSizing: "border-box"
  },
  hoursCount: {
    textAlign: "left",
    position: "absolute",
    display: "inline-block",
    height: 20,
    width: "auto",
    padding: "0px 10px 0px 0px",
    background: 'rgba(48,73,103,0.8)',
    color: '#ffffff',
    borderRadius: 10,
    '& .svgIcon':{
      width: 20,
      height: 20,
      position: "relative"
    },
    '& .svgFillWhite > g > path': {
      fill: "#ffffff"
    },
    '& .hoursText': {
      display: "inline-block",
      //lineHeight: "16px",
      fontSize: "12px",
      position: "relative",
      left: "4px",
      top: "-6px"
    },
    '& .stateText': {
      display: "inline-block",
      fontSize: "12px",
      position: "relative",
      "text-transform": "uppercase",
      left: "4px",
      top: "-6px"
    }
  },
  more: {
    marginTop: 24,
    marginBottom: 90,
    display: "flex",
    justifyContent: "center"
  },
  cardTitle: {
    padding: "8px 0",
    borderBottom: "1px dashed #CACCD1"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000,
    [theme.breakpoints.down("md")]: {
      position: "fixed"
    }
  },
  drawerClosed: {
    width: 0
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    padding: 20,
    top: 65
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0
  }
}));

const ModuleInfoDrawer = ({
  open,
  moduleId,
  history,
  hideLink,
  moduleCard,
  getModule
}) => {
  const classes = useStyles();

  React.useEffect(() => {
    if (moduleId !== -1) {
      getModule(moduleId);
    }
  }, [moduleId]);

  const onLinkClick = () => {
    history.push(`/work/app/manage/resources/programs/mymodules/${moduleCard.id}`);
  };

  return (
    <Drawer
      className={open ? classes.drawerOpen : classes.drawerClosed}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      {moduleCard ? (
        <div>
          <ProgramImage fileId={moduleCard.logo} />
          <div className={classes.cardTitle}>
            <Typography className={classes.typo} align="center">
              {moduleCard.name}
            </Typography>
            <div className={classes.stateBlock}>
              <Grid container direction="row" justify="space-between" alignItems="center">
                <Grid item xs={5}>
                  <Chip color="primary"
                        style={{ backgroundColor: "rgba(48,73,103,0.8)"}}
                        size="small"
                        icon={<AccessTimeIcon />}
                        label={`${moduleCard.duration || 0} ч.`}/>
                </Grid>
                <Grid item xs={7}>
                  <Chip color="primary"
                        style={{ backgroundColor: StateTextColor(moduleCard.statusId)}}
                        size="small"
                        icon={SmallStateIcon(moduleCard.statusId, "svgIcon svgFillWhite")}
                        label={moduleCard.statusName}/>
                </Grid>
            </Grid>
            </div>
          </div>
          <CardInfoField field="Профессия:" value={moduleCard.specName || '-'} />
          <CardInfoField field="Компетенция:" value={moduleCard.skillName || '-'} />
          <CardInfoField field="Форма обучения:" value={moduleCard.educationFormName || '-'} />
          <CardInfoField field="Форма аттестации:" value={moduleCard.trialFormName || '-'} />
          <div className={classes.devider}></div>

          <div style={{ "marginTop": 16, "fontSize": 12 }}>
            <Typography style={{ "display": "block"}}
              variant="caption"
              color="textSecondary">
              Составители:
            </Typography>
              <div style={{ "display": "block"}}>
                {moduleCard.authors.map(({ name, post }) =>
                <CardPersonBlock name={name} desc={post}/>)}
              </div>
          </div>

          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
    </Drawer>
  );
};

const mapStateToProps = state => ({
  moduleCard:  state.programs.moduleCard
});

const mapDispatchToProps = dispatch => ({
  getModule: id => dispatch(getModule(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ModuleInfoDrawer));
